var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "quote-member-new"
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v("First Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.firstName,
      expression: "firstName"
    }],
    staticClass: "input-field",
    class: {
      'form-invalid': _vm.$v.firstName.$error
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name"
    },
    domProps: {
      "value": _vm.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value;
      }
    }
  }), !_vm.$v.firstName.required && _vm.$v.firstName.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The first name field is required ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title text-left"
  }, [_vm._v("Last Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.lastName,
      expression: "lastName"
    }],
    staticClass: "input-field",
    class: {
      'form-invalid': _vm.$v.lastName.$error
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name"
    },
    domProps: {
      "value": _vm.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value;
      }
    }
  }), !_vm.$v.lastName.required && _vm.$v.lastName.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The last name field is required ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title mb-2"
  }, [_vm._v("DOB")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('date-picker', {
    staticClass: "send-quote-date-picker",
    class: {
      'date-invalid': _vm.$v.dob.$error
    },
    attrs: {
      "aria-describedby": "input-feedback",
      "placeholder": "MM/DD/YYYY",
      "value-type": "format",
      "format": "MM/DD/YYYY"
    },
    on: {
      "input": function input($event) {
        return _vm.$v.dob.$touch();
      }
    },
    model: {
      value: _vm.dob,
      callback: function callback($$v) {
        _vm.dob = $$v;
      },
      expression: "dob"
    }
  }), !_vm.$v.dob.required && _vm.$v.dob.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The dob field is required ")]) : _vm._e(), _vm.$v.dob.required && _vm.$v.dob.$error ? _c('div', {
    staticClass: "form-error ml-3 mt-2"
  }, [_vm._v(" You must be 18 years to proceed ")]) : _vm._e()], 1), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Zip")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zip,
      expression: "zip"
    }],
    staticClass: "input-field",
    class: {
      'form-invalid': _vm.$v.zip.$error
    },
    attrs: {
      "type": "number",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "maxlength": "5",
      "placeholder": "Enter Zip"
    },
    domProps: {
      "value": _vm.zip
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value;
      }, function ($event) {
        return _vm.$v.zip.$touch();
      }]
    }
  }), !_vm.$v.zip.required && _vm.$v.zip.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The zip field is required ")]) : _vm._e(), _vm.$v.zip.required && _vm.$v.zip.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Enter 5 digit zip code. ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Tier")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tier,
      expression: "tier"
    }],
    staticClass: "send-custom-select  mt-1",
    class: {
      'form-invalid': _vm.$v.tier.$error
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.tier = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Choose Tier")]), _vm._l(_vm.tierOptions, function (tier, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": tier.value
      }
    }, [_vm._v(_vm._s(tier.text))]);
  })], 2), !_vm.$v.tier.required && _vm.$v.tier.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The tier field is required ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.salary,
      expression: "salary"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "number",
      "placeholder": "Enter Salary"
    },
    domProps: {
      "value": _vm.salary
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.salary = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Gender")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gender,
      expression: "gender"
    }],
    staticClass: "send-custom-select  mt-1",
    class: {
      'form-invalid': _vm.$v.gender.$error
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Choose Gender")]), _vm._l(_vm.genderOptions, function (gender, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": gender.value
      }
    }, [_vm._v(_vm._s(gender.text) + " ")]);
  })], 2), !_vm.$v.gender.required && _vm.$v.gender.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The gender field is required ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Email")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "input-field",
    class: {
      'form-invalid': _vm.$v.email.$error
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }, function ($event) {
        return _vm.$v.email.$touch();
      }]
    }
  }), !_vm.$v.email.required && _vm.$v.email.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The email field is required ")]) : _vm._e(), _vm.$v.email.required && _vm.$v.email.$invalid ? _c('div', {
    staticClass: "form-error  text-left ml-3 mt-2"
  }, [_vm._v(" Enter valid email address ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Enrollment Platform")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.platform,
      expression: "platform"
    }],
    staticClass: "send-custom-select  mt-1",
    class: {
      'form-invalid': _vm.$v.platform.$error
    },
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.platform = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Choose Enrollment Platform")]), _vm._l([_vm.platform], function (platform, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": platform
      }
    }, [_vm._v(_vm._s(platform.text) + " ")]);
  })], 2), !_vm.$v.platform.required && _vm.$v.platform.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The platform field is required ")]) : _vm._e()]), _vm.tier.length && _vm.tier !== 'IO' ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm.tier === 'IS' || _vm.tier === 'IF' ? _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title mb-2"
  }, [_vm._v("DOB (Spouse / Partner)")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('date-picker', {
    staticClass: "send-quote-date-picker",
    class: {
      'date-invalid': _vm.$v.spouseDob.$error
    },
    attrs: {
      "aria-describedby": "input-feedback",
      "placeholder": "MM/DD/YYYY",
      "value-type": "format",
      "format": "MM/DD/YYYY"
    },
    on: {
      "input": function input($event) {
        return _vm.$v.spouseDob.$touch();
      }
    },
    model: {
      value: _vm.spouseDob,
      callback: function callback($$v) {
        _vm.spouseDob = $$v;
      },
      expression: "spouseDob"
    }
  }), !_vm.$v.spouseDob.required && _vm.$v.spouseDob.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The spouse dob field is required ")]) : _vm._e(), _vm.$v.spouseDob.required && _vm.$v.spouseDob.$error ? _c('div', {
    staticClass: "form-error ml-3 mt-2"
  }, [_vm._v(" Spouse age must be at least 18 years ")]) : _vm._e()], 1) : _vm._e(), _vm.tier === 'IC' || _vm.tier === 'IF' ? _c('div', {
    staticClass: "col-xxl-4 col-lg-4 col-md-6 mb-3"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v("Children")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.childNumber,
      expression: "childNumber"
    }],
    staticClass: "input-field",
    class: {
      'form-invalid': _vm.$v.childNumber.$error
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Number Of Children"
    },
    domProps: {
      "value": _vm.childNumber
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.childNumber = $event.target.value;
      }, function ($event) {
        return _vm.$v.childNumber.$touch();
      }]
    }
  }), !_vm.$v.childNumber.required && _vm.$v.childNumber.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" The children field is required ")]) : !_vm.$v.childNumber.greaterThanZero ? _c('div', {
    staticClass: "form-error ml-3 mt-2"
  }, [_vm._v(" The number of children must be 0 (min) and 8 (max) ")]) : _vm.$v.childNumber.required && !_vm.$v.childNumber.isWholeNumber ? _c('div', {
    staticClass: "form-error ml-3 mt-2"
  }, [_vm._v(" The number can't be negative or decimal ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "new-quote-btn mt-0",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goToNextStep
    }
  }, [_vm._v("Next")])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-left"
  }, [_vm._v("Salary "), _c('span', {
    staticClass: "optional-text"
  }, [_vm._v("(Optional)")])]);
}]

export { render, staticRenderFns }